import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { axios } from "lib/axios";
import {
  showMaintenanceBanner,
  getDownTimeDetails,
  getDownTimeDetailsInProgress,
} from "../../actions/adminSettings/maintenanceBanner/ActionsMaintenanceBanner";
import IntlMessages from "util/IntlMessages";

export const MOBILE_VIEW = 768;
export const HTTP_REQUEST_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
};

export const HTTP_REQUEST_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  SERVER_STOPPED: 418,
};

let stateCopy = {};

/**This Component is called inside the App.js component, to be shown accross the application */
function DownTimeBanner(props) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.ReducerMaintenanceBanner);
  const viewLanguage = useSelector((state) => state.settings.viewLanguage);
  const isTranslationsLoaded = useSelector(
    (state) => state.settings.isInitialTranslationsLoadComplete
  );

  /**To make the state variable updated in side the call back of interceptor */
  stateCopy = state;

  /**
   * Fetch downtime details only after translations have loaded (locale has settled).
   * Re-fetches when user switches language. Saga reads latest locale from the store.
   */
  useEffect(() => {
    if (!isTranslationsLoaded) return;
    dispatch(getDownTimeDetailsInProgress());
    dispatch(getDownTimeDetails());
  }, [dispatch, viewLanguage, isTranslationsLoaded]);

  /**
   * TODO: This interceptor should be moved to a separate file like reportLodingInterceptor.js
   * and should be initialized in interceptors/index.js to maintain consistency
   * and avoid potential duplicate interceptors
   */

  /**
   * This is a Axios interceptor to intercept every API call,
   * there are two call back functions, any one will be called on every api call done using axios.
   * first call back : is called when there is a response from any API.
   * second call back: is called when there is a error from any API.
   */
  axios.interceptors.response.use(
    (response) => {
      if (
        typeof response !== "undefined" &&
        typeof response.data !== "undefined"
      ) {
        /**If Banner is disabled  */
        if (stateCopy.enableBanner === false) {
          /**And downtime key is present then get the details */
          if (
            response.data["downtime"] === true &&
            (stateCopy.downTimeDetailsFetchStatus ===
              HTTP_REQUEST_STATUS.NOT_STARTED ||
              stateCopy.downTimeDetailsFetchStatus === HTTP_REQUEST_STATUS.FAIL)
          ) {
            dispatch(getDownTimeDetailsInProgress());
            dispatch(getDownTimeDetails());
          }
        }

        /**Previously Banner is enabled and if it's not found  */
        if (stateCopy.enableBanner === true) {
          /**then make the api call to check if downtime has ended */
          if (
            typeof response.data["downtime"] === "undefined" &&
            stateCopy.downTimeDetailsFetchStatus ===
              HTTP_REQUEST_STATUS.FAIL &&
            !response.request.responseURL.includes("/downtime/next")
          ) {
            dispatch(getDownTimeDetailsInProgress());
            dispatch(getDownTimeDetails());
          }
        }
      }

      /**Always return response */
      return response;
    },
    (error) => error
  );

  const handleClick = () => {
    dispatch(showMaintenanceBanner(false));
  };

  return (
    <>
      {state.enableBanner === true &&
        state.showBanner === true &&
        window.innerWidth > MOBILE_VIEW && (
          <div className="row down_time_banner align-items-center">
            <div className="col">
              <div className="d-flex align-items-center">
                <div className="maintenance_banner_icon mr-2 flex-shrink-0"></div>
                <div className="flex-grow-1">
                  {state.downTimeMessage ? (
                    <span>{state.downTimeMessage}</span>
                  ) : (
                    <>
                      <IntlMessages id="DIC_KEY_MAINTENANCE_BANNER_MESSAGE_PART1" />
                      {state.downTimeStartDate === "" ? (
                        <IntlMessages id="DIC_KEY_MAINTENANCE_BANNER_MESSAGE_PART3" />
                      ) : (
                        <span>{state.downTimeStartDate}</span>
                      )}
                      <IntlMessages id="DIC_KEY_MAINTENANCE_BANNER_MESSAGE_PART2" />
                      <span>{state.diffInhrs > 0 ? state.diffInhrs : 6}</span>
                      <IntlMessages id="DIC_KEY_MAINTENANCE_BANNER_MESSAGE_PART4" />
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div
                className="maintenance_banner_cancel_icon"
                onClick={handleClick}
              ></div>
            </div>
          </div>
        )}
      {props.children}
    </>
  );
}

export default DownTimeBanner;
